export default {
  collection:{
    en: 'Collection',
    ja: 'コレクション'
  },
  copied:{
    en: 'Copied',
    ja: 'コピー機'
  },
  KYCComingSoon: {
    en: "KYC coming soon",
    ja: "近日中にKYC"
  },
  metamaskWalletDisconnectNotificationTitle:{
    en: 'Wallet not disconnected',
    ja: 'ウォレットが切断されていない'
  },
  metamaskWalletDisconnectNotificationSubtitle:{
    en: 'Please use Metamask to disconnect',
    ja: 'メタマスクで接続を解除してください'
  },
  disconnectWallet:{
    en: 'Disconnect wallet',
    ja: 'ウォレットの接続を解除する'
  },
}